import MentionText from './MentionText';
import TimeAgo from './TimeAgo';
import UserBadge from './UserBadge';

// Ένα σχόλιο ανθρώπου, όπου κι αν ζει.
//
// ⚠ **ΓΙΑΤΙ ΥΠΑΡΧΕΙ ΑΥΤΟ ΤΟ ΑΡΧΕΙΟ, ΚΑΙ ΓΙΑΤΙ ΑΡΓΗΣΕ.**
//
// Η σχεδίαση της φυσαλίδας —ταυτότητα με πρόσωπο, κείμενο σε πλαίσιο με **ορατό
// όριο**, ημερομηνία **κάτω** από τη φυσαλίδα και στοιχισμένη με αυτήν— γεννήθηκε
// από εύρημα χειροκίνητου ελέγχου: χωρίς όριο, δέκα σχόλια διαβάζονταν ως ένα
// κείμενο με έντονες λέξεις ενδιάμεσα.
//
// **Η διόρθωση εφαρμόστηκε ως σήμανση μέσα σε ένα αρχείο, όχι ως συστατικό.**
// Άρα οι σημειώσεις προόδου των καθηκόντων —γραμμένες **νωρίτερα**, σε άλλο
// task— δεν την πήραν ποτέ: δεν ήταν «δεύτερη υλοποίηση που αγνόησε την πρώτη»,
// ήταν η **πρώτη που έμεινε πίσω**, και κανένας μηχανισμός δεν τις συνέδεε. Όποιος
// ήθελε να τις ευθυγραμμίσει δεν είχε τι να επαναχρησιμοποιήσει: το σχέδιο
// υπήρχε ως **JSX μέσα σε συστατικό**, όχι ως πράγμα με όνομα.
//
// Το μάθημα δεν είναι «να προσέχουμε». Είναι ότι **σχέδιο που δεν έχει όνομα δεν
// μπορεί να επαναχρησιμοποιηθεί**, και επομένως θα αποκλίνει στο πρώτο δεύτερο
// σημείο χρήσης — ανεξάρτητα από τη σειρά με την οποία γράφτηκαν τα δύο.

// ⚠ **ΚΑΙ ΜΙΑ ΔΕΥΤΕΡΗ ΕΥΡΕΣΗ, ΠΟΥ ΦΑΝΗΚΕ ΜΟΝΟ ΣΤΗΝ ΕΞΑΓΩΓΗ.**
//
// Η αρχική φυσαλίδα των σχολίων πόρου ζητούσε `bg-surface-subtle` και
// `border-line`. **Καμία από τις δύο κλάσεις δεν παράγει κανόνα**: δεν υπάρχουν
// αντίστοιχα σημασιολογικά χρώματα, και το εργαλείο στυλ **αγνοεί σιωπηλά** ό,τι
// δεν αναγνωρίζει — καμία προειδοποίηση, καμία αποτυχία παραγωγής.
//
// Δηλαδή η φυσαλίδα που ο χειροκίνητος έλεγχος πέρασε ως «με ορατό όριο» δεν
// είχε **ούτε φόντο ούτε όριο**: ό,τι φαινόταν προερχόταν από την εσοχή και τις
// στρογγυλεμένες γωνίες. Επαληθεύτηκε στο **παραγόμενο φύλλο στυλ**, όπου οι δύο
// κλάσεις δεν εμφανίζονται καθόλου.
//
// Χρησιμοποιούνται πλέον **υπαρκτές** κλάσεις: το `accent-soft` είναι
// **ακριβώς η ίδια τιμή** με το `info-soft` των σχεδιαστικών σταθερών
// (`#F3E6F3`), και το `border-border` είναι το μόνο σημασιολογικό όριο που
// πράγματι παράγεται. Η αντίθεση και των δύο ελέγχεται ήδη από την παραγωγή των
// σταθερών.
export default function CommentBubble({ author, text, createdAt }) {
    return (
        <li className="flex flex-col gap-1.5">
            <UserBadge user={author} />

            {/* Η φυσαλίδα έχει **ορατό όριο**, όχι μόνο ελαφρώς διαφορετικό φόντο.
                Η γωνία επάνω-αριστερά είναι κομμένη ώστε να «δείχνει» προς την
                ταυτότητα από πάνω: το σχόλιο ανήκει σε πρόσωπο. */}
            {/* D44: το κείμενο περνά από **ένα** σημείο απόδοσης, ώστε η
                επισήμανση των αναφορών να μην μπορεί να αποκλίνει ανάμεσα στα
                σχόλια πόρου και στις σημειώσεις προόδου — που είναι ακριβώς το
                μάθημα για το οποίο υπάρχει αυτό το αρχείο. */}
            <p className="ms-9 rounded-2xl rounded-ss-sm border border-border bg-accent-soft px-3.5 py-2.5 text-sm whitespace-pre-line">
                <MentionText text={text} />
            </p>

            {/* Η ημερομηνία **κάτω** από τη φυσαλίδα και στοιχισμένη με αυτήν. Δίπλα
                στο όνομα διεκδικούσε την ίδια γραμμή με την ταυτότητα του συντάκτη,
                που είναι η πληροφορία με προτεραιότητα· από κάτω, διαβάζεται ως
                υποσημείωση του σχολίου — ό,τι πράγματι είναι. */}
            <TimeAgo date={createdAt} className="ms-9 text-xs text-muted" />
        </li>
    );
}
